import { toast } from "react-toastify";
import { ArchiveTenderDocument, ArchiveTenderMutation, ArchiveTenderMutationVariables, FetchTenderByIdDocument } from "@/graphql/__generated__/graphql";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";

export default function useArchiveTenderMutationHook() {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [archiveTenderMutation, { loading, error }] = useMutation<ArchiveTenderMutation, ArchiveTenderMutationVariables>(ArchiveTenderDocument, {
    onCompleted() {
      toast(CustomToastComponent, {
        toastId: "tender-archived-success",
        data: {
          title: t("toasts.tenderarchivedsuccessfully"),
          type: "success",
        }
      });
    },
    refetchQueries: [
      {
        query: FetchTenderByIdDocument,
        variables: { id: Number(tenderID) }
      }
    ]
  });

  return {
    archiveTenderMutation,
    loading,
    error
  };
}
